module.exports = __webpack_public_path__ + "static/media/unlock.af16838d.svg";